﻿/**
 * Third Party imports
 */

import "./jQuery.js"
import "./Alpine.js"
import 'jquery-ajax-unobtrusive';
import 'jquery-validation'
import 'jquery-validation-unobtrusive'
import "./LazyLoad.js"
import "./sticky.js";


import { utils } from './utils';
import { ftui } from './ftui/ftui.js';
import { controls } from './ftui/controls/controls.js';

window._utils = utils;
window.ftui = ftui;
window.ftui.controls = controls;